import React, { useContext, useMemo } from 'react';
import V3ContentScreenContext from './V3ContentScreenContext';
import { contentTypeCheckers } from '../ContentIndex/useContent';
import V3ContentShareButton from './V3ContentShareButton';
import V3PublishButton from './V3PublishButton';
import { UIVersionContext } from '../../../contextProviders/SplashScreenProviders/UserAndAccountProviders/UIVersionProvider';

const V3PublishOrShareButton = ({ fallback }: { fallback?: JSX.Element }) => {
  const { isV3 } = useContext(UIVersionContext);
  const { content } = useContext(V3ContentScreenContext);

  const v3Access = useMemo((): V3Access | undefined => {
    if (!content) {
      return undefined;
    }

    if (contentTypeCheckers.isDashboard(content)) {
      return content.dashboard.v3Access;
    } else if (contentTypeCheckers.isReport(content)) {
      return content.report.v3Access;
    } else if (contentTypeCheckers.isGoal(content)) {
      return content.goal.v3Access;
    } else if (contentTypeCheckers.isScorecard(content)) {
      return content.scorecard.v3Access;
    } else if (contentTypeCheckers.isBoard(content)) {
      return content.board.v3Access;
    }

    return undefined;
  }, [content]);

  const isV3Published = useMemo((): boolean | undefined => {
    if (!content) {
      return undefined;
    }

    if (contentTypeCheckers.isDashboard(content)) {
      return content.dashboard.isV3Published;
    } else if (contentTypeCheckers.isReport(content)) {
      return content.report.isV3Published;
    } else if (contentTypeCheckers.isGoal(content)) {
      return content.goal.isV3Published;
    } else if (contentTypeCheckers.isScorecard(content)) {
      return content.scorecard.isV3Published;
    } else if (contentTypeCheckers.isBoard(content)) {
      return content.board.isV3Published;
    }

    return undefined;
  }, [content]);

  if (!content) {
    if (fallback) {
      return <>{content}</>;
    }
    return null;
  }

  if (!isV3) {
    return null;
  }

  if (!v3Access) {
    return null;
  }

  if (isV3Published === undefined) {
    return null;
  }

  if (!isV3Published) {
    return <V3PublishButton />;
  }

  return <V3ContentShareButton v3Access={v3Access} />;
};

export default V3PublishOrShareButton;
